import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Upload from '../components/Upload';
import { commonConfigCaller } from './FeatureDetails';
import { plazaServices } from './tollPlaza/plazaReportService';
import moment from 'moment';
import { Tooltip } from 'primereact/tooltip';

const ProductCatalogUpload = () => {
    const [data, setData] = useState([]);
    const [file, setFile] = useState()
    const [disableBtn, setDisableBtn] = useState(true)
    const [refresh, setRefresh] = useState(false);
    const [infoMsg, setInfoMsg] = useState("")
    const serviceId = localStorage.getItem('serviceId')
    useEffect(() => {
        Promise.all([plazaServices.general(serviceId, { filter: {}, "sort": [["modified_ts", -1]] }, "nq-ProductCatalogue-file-processing")]).then((res) => {
            setFile()
            setInfoMsg("")
            setDisableBtn(true)
            setData(res[0])
        })
    }, [refresh])
    const handleFileUpload = async () => {
        try {
            setDisableBtn(true);

            if (!file) {
                throw new Error("Please select a file before uploading.");
            }

            let formData = new FormData();
            formData.append("serviceId", serviceId);
            formData.append("file", file);
            formData.append("userID", localStorage.getItem('emailId'));
            formData.append("process", "ProductCatalogue");

            const res = await commonConfigCaller(
                "imaginehomes/uploadProductCatalogue/",
                "post",
                formData,
                process.env.REACT_APP_API_PARSER_URL
            );

            console.log("Response:", res);

            if (res?.status === 200) {
                setInfoMsg("File Uploaded Sucessfully")
            } else {
                setInfoMsg("Failed to upload file.")
            }

        } catch (error) {
            setInfoMsg("Failed to upload file.")
            console.error("Error during file upload:", error.message);
            alert(`Error: ${error.message}`);
        } finally {
            let temp = {
                fileName: file.name,
                "status": "Pending",
                upload_time: moment().format('YYYY-MM-DD HH:mm:ss')
            }
            setData([temp, ...data])
            setTimeout(() => { setRefresh(!refresh) }, 5000)
            setDisableBtn(true); // Ensure the button is enabled even on error
        }
    };
    const handleChange = (e) => {
        const file = e.target.files[0]
        setFile(file)
        setDisableBtn(false)
    }
    const acceptedFormat = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    const headClass = "sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular";
    const bodyClass = "text-md p-2 font-Gerstner-ProgramRegular"
    const getUrl = async (row) => {
        try {
            let payload = new FormData();
            payload.append('serviceId', serviceId);
            payload.append('location', row.location);
            payload.append('getURL', 'true');

            const res = await commonConfigCaller(
                "imaginehomes/getProductCatalogueDetails/",
                "post",
                payload,
                process.env.REACT_APP_API_PARSER_URL
            );
            const downloadUrl = res.data?.[0]?.error?.download_url;
            if (downloadUrl) {
                const anchor = document.createElement('a');
                anchor.href = downloadUrl;
                anchor.download = 'ErrorFile.xlsx';
                anchor.style.display = 'none';
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            } else {
                console.warn("Download URL not found.");
            }

        } catch (error) {
            console.error("Error fetching URL:", error);
        }
    };
    const showData = (row, field) => {
        const value = field.split('.').reduce((acc, key) => acc?.[key], row);
        return <p className={`${bodyClass} ml-3`}>{value ?? 0}</p>;  // Fallback to 0 if undefined
    };
    const showError = (row) => {
        return row.error?.errorCount > 0 ?
            <Button
                icon="pi pi-download"
                label="Get Error File"
                style={{
                    color: "#9AAB89",
                    backgroundColor: "white",
                    padding: "0.5rem 1rem",
                    marginLeft:"2px"
                }}
                className={`${bodyClass}`}
                onClick={() => getUrl(row)}
            />
            : null
    }
    return (
        <div className='col-12 card shadow-3 p-3 border-round' >
            <Upload handleUpload={handleFileUpload} accept={acceptedFormat} onchange={handleChange} fileName={file?.name} error={infoMsg} uploadTextClassName='font-larken  charcoal-color mt-3 mb-3 block text-xl'>
                {<>
                    <Button className='text-xl mb-4 font-larken px-5 p-button-rounded sage-ivory' label="Upload" onClick={handleFileUpload} disabled={disableBtn} />
                    <a className='text-xl font-larken m-0 ' href={`${process.env.REACT_APP_IMAGE_STATIC_URL}/ProductCatalogTemplate.xlsx`} download>
                        Download Template
                    </a></>}
            </Upload>
            <div className='col-12 card mt-4'>
                <DataTable
                    value={data}
                    paginator
                    rows={5}
                    responsiveLayout="scroll"
                    emptyMessage="No data found"
                >
                    <Column header="Date" body={(item) => { return moment(item.upload_time, 'YYYY-MM-DD').format('MMMM Do YYYY'); }} headerClassName={headClass} bodyClassName={bodyClass} />
                    <Column header="File Name" field="fileName" headerClassName={headClass} bodyClassName={bodyClass} />
                    <Column header="File Status" field="status" headerClassName={headClass} bodyClassName={bodyClass} />
                    <Column header="Total Records" body={(row) => { return showData(row, "receivedCount") }} headerClassName={headClass} bodyClassName={`${bodyClass}`} />
                    <Column header="Uploaded" body={(row) => { return showData(row, "success.successCount") }} headerClassName={headClass} bodyClassName={`${bodyClass}`} />
                    <Column header="Failed" body={(row) => { return showData(row, "error.errorCount") }} headerClassName={headClass} bodyClassName={`${bodyClass}`} />
                    <Column
                        header=""
                        body={(row) => (
                            row.status === "Failed" ? (
                                <div style={{ color: "red" }} className="grid align-items-center mt-1" >
                                    <i className="pi pi-exclamation-triangle mr-1"></i>
                                    {"File format not correct, please use the downloaded template"}
                                </div>
                            ) : row.status === "Procesed" && row["validatation_errors"].length ? (
                                <div style={{ color: "#FFBF00" }} className="grid align-items-center mt-1" id={`tooltip-${row.id}`}>
                                    <i className="pi pi-exclamation-triangle mr-1"></i>
                                    <Tooltip
                                        className="col-3 text-red-300 col-3"
                                        target={`#tooltip-${row.id}`}
                                        content={row["validatation_errors"].join(",")}
                                        escape={false} // Allows HTML rendering inside Tooltip
                                    />
                                    {"warning:columns missing from the file"}
                                    {showError(row)}
                                </div>
                            ) : showError(row) // Ensure showError(row) returns a valid React node or null
                        )}
                        bodyClassName={bodyClass}
                        headerClassName={headClass}
                    />
                </DataTable>
            </div>
        </div>
    );
};

export default ProductCatalogUpload;
